import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const THUMB_MARGIN = 16; // px

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, min = 0, max = 100, value, defaultValue, onValueChange, ...props }, ref) => {
  // We no longer clamp the value in onValueChange, so the full range (min to max) is selectable.
  // Instead, we set the Track's width to calc(100% - 32px) and center it, so the Thumb cannot overlap the ends.

  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none select-none items-center",
        className
      )}
      min={min}
      max={max}
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      {...props}
    >
      <SliderPrimitive.Track 
        className="relative h-9 w-full grow overflow-hidden rounded-full bg-sky-400 opacity-20" 
        style={{ width: 'calc(100% + 32px)', margin: '0 auto' }}
      >
        <SliderPrimitive.Range className="absolute h-full bg-sky-400 opacity-20" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb 
        className="block h-6 w-6 rounded-full border-2 border-sky-900 bg-sky-500 ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" 
      />
    </SliderPrimitive.Root>
  );
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
